// extracted by mini-css-extract-plugin
module.exports = {"textarea":"_9e1425b4d3--textarea--ApQZp"};